import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrInstructionsText = ({ instructions }) => (
  <SrBox borderRadius="14px" backgroundColor="#f1f1f1" padding="16px 20px">
    <SrText font="greycliff" weight="600" size="16" color="blueGreycliff" lineHeight="24px">
      {instructions}
    </SrText>
  </SrBox>
);

SrInstructionsText.propTypes = {
  instructions: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

SrInstructionsText.displayName = 'SrInstructionsText';

export default SrInstructionsText;
